import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DateTimeRangePicker } from '@optios/react-date-time-range-picker'
import moment, { Moment } from 'moment'
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useCookie from 'react-use-cookie'

import Message from '../../App/Components/Message/Message'
import TopBar from '../../App/Components/TopBar/TopBar'
import TopBarButton from '../../App/Components/TopBar/TopBarButton/TopBarButton'
import { useAppDispatch, useAppSelector } from '../../App/Hooks/reduxHooks'

import Spinner from './../../App/Components/Spinner/Spinner'
import { IDeletedAppointment } from './Client/IDeletedAppointment'
import { getDeletedAppointments } from './store/Actions'
import style from './style.scss'

const TrashCan = () => {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()
  const [calendarDate] = useCookie(
    'calendar.date',
    moment().format('YYYY-MM-DD'),
  )
  const [startDate, setStartDate] = useState<Moment>(moment(calendarDate))
  const [endDate, setEndDate] = useState<Moment>(moment(calendarDate))

  const [isRangePickerVisible, setIsRangePickerVisible] = useState(false)

  const trashCan = useAppSelector(state => state.calendar.trashCan)
  const loading = trashCan.isLoading
  const errorMessage = trashCan.error
  const deletedAppointments = trashCan.deletedAppointments

  useEffect(() => {
    if (!deletedAppointments && !loading &&
      !errorMessage
    ) {
      dispatch(getDeletedAppointments(startDate, endDate))
    }
  }, [])

  const content = () => {
    if (loading || typeof deletedAppointments === 'undefined') {
      return <Spinner />
    }

    return deletedAppointments.length === 0 ? (
      <div className={style.container}>
        <Message>{t('No appointments found.')}</Message>
      </div>
    ) : (
      deletedAppointments.map((deletedAppointment: IDeletedAppointment) => {
        const deletedStartDate = moment(deletedAppointment.startsAt)
        const deleteDate = moment(deletedAppointment.deletedAt)

        return (
          <div className={style.container} key={deletedAppointment.id}>
            <div className={style.startDate}>
              {deletedStartDate.format('dddd D MMMM YYYY')}
            </div>
            <div className={style.info}>
              <h4>{deletedAppointment.customer.fullName}</h4>
              <div>
                {t('Appointment at')} {deletedStartDate.format('HH:mm')}
              </div>
              <div>
                {deletedAppointment.blocks
                  .map((block: any) => block.name)
                  .join(', ')}
              </div>
              <div className={style.deleted}>
                {t('Deleted at')} {deleteDate.format('dddd D MMMM YYYY, HH:mm')}
              </div>
            </div>
          </div>
        )
      })
    )
  }
  const onChange = (newStartDate: Moment, newEndDate: Moment) => {
    setStartDate(newStartDate)
    setEndDate(newEndDate)
    dispatch(getDeletedAppointments(newStartDate, newEndDate))
    if (newStartDate.diff(newEndDate, 'days') !== 0) {
      setIsRangePickerVisible(false)
    }
  }

  return (
    <div>
      <TopBar>
        <TopBarButton href={'/calendar'}>
          <FontAwesomeIcon icon={faTimes} />
        </TopBarButton>
        <div>
          <button
            className={style.rangePickerBtn}
            onClick={() => setIsRangePickerVisible(!isRangePickerVisible)}>
            {startDate.format('dddd D MMMM YYYY')} -{' '}
            {endDate.format('dddd D MMMM YYYY')}
          </button>
        </div>
        <div /> {/* Spacer */}
      </TopBar>
      {isRangePickerVisible ? (
        <div className={style.absolute}>
          <div className={style.rangePicker}>
            <DateTimeRangePicker
              range
              onChange={(date1: Moment, date2: Moment) =>
                onChange(date1, date2)
              }
              fromDate={startDate}
              untilDate={endDate}
            />
          </div>
        </div>
      ) : (
        ''
      )}
      <h2 className={style.title}>{t('Removed appointments')} </h2>
      {deletedAppointments ? content() : <Spinner />}
    </div>
  )
}

export default TrashCan
